import { faUserGroup } from "@fortawesome/pro-regular-svg-icons/faUserGroup";
import { faUserTie } from "@fortawesome/pro-regular-svg-icons/faUserTie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "@onefront/react-sdk";
import { WsTag } from "@onefront/react-workspace-components";
import { ExtendedTypography } from "@vapor/react-extended";
import { Box, Skeleton, Stack } from "@vapor/react-material";
import { IntermediaryListDto } from "../../../../../@types/dtos/intermediaries/IntermediaryListDto";
import React from "react";

const DetailsIntermediary = ({ intermediary, loading }: { intermediary: IntermediaryListDto; loading?: boolean }) => {
    const { t } = useTranslation();
    if (!intermediary) {
        return null;
    }
    return (
        <Stack spacing={2}>
            <Box>
                <WsTag label={<>Intermediario</>} textColor="DarkImperialBlue" type="bodySmall500" loading={loading} />
            </Box>
            <Box>
                <ExtendedTypography variant="titleMedium" color="primary.textTitleColor">
                    <Stack direction={"row"} spacing={1}>
                        {loading ? (
                            <Skeleton width={200} variant="text" />
                        ) : (
                            <>
                                <Box>
                                    <FontAwesomeIcon icon={intermediary?.type === "C" ? faUserGroup : faUserTie} />
                                </Box>
                                <Box>
                                    {intermediary?.type === "C"
                                        ? intermediary?.description
                                        : `${intermediary?.details?.name} ${intermediary?.details?.surname}`}
                                </Box>
                            </>
                        )}
                    </Stack>
                </ExtendedTypography>
            </Box>
            <Box>
                <Stack spacing={1}>
                    <ExtendedTypography variant="body">
                        <Stack direction={"row"} spacing={1}>
                            {loading ? (
                                <Skeleton width={120} variant="text" />
                            ) : (
                                <>
                                    <Box>{t("details.intermediaries.drawer.create.cards.vatIdentifier")}:</Box>
                                    <Box>{intermediary?.vatNumber}</Box>
                                </>
                            )}
                        </Stack>
                    </ExtendedTypography>
                    <ExtendedTypography variant="body">
                        <Stack direction={"row"} spacing={1}>
                            {loading ? (
                                <Skeleton width={120} variant="text" />
                            ) : (
                                <>
                                    <Box>{t("details.intermediaries.drawer.create.cards.taxIdentifier")}:</Box>
                                    <Box>{intermediary?.taxId}</Box>
                                </>
                            )}
                        </Stack>
                    </ExtendedTypography>
                </Stack>
            </Box>
        </Stack>
    );
};

export default DetailsIntermediary;
